<dx-list
  class="transport-intervention-realtime-list"
  [dataSource]="ds"
  [searchEnabled]="true"
  [searchExpr]="['name', 'domain_name']"
  [grouped]="listGrouped"
  [searchTimeout]="500"
  pageLoadMode="scrollBottom"
  [searchEditorOptions]="{stylingMode: 'filled'}"
  [collapsibleGroups]="true"
  [repaintChangesOnly]="true"
  [scrollingEnabled]="false"
  selectAllMode="allPages"
  (onItemClick)="itemClick($event)"
  searchMode="contains">
  <div *dxTemplate="let data of 'item'">
    <app-transport-interventions-realtime-list-item (menuClick)="menuClick($event, data)" [item]="data"></app-transport-interventions-realtime-list-item>
  </div>
</dx-list>
<app-transport-interventions-realtime-report></app-transport-interventions-realtime-report>
